import {Metric} from 'app_api/projects/metrics/types';

export enum MetricsTrackingEvent {
  SaveMetric = `Saved Metric`,
}

export enum SaveMetricEventType {
  Create = `Create`,
  Update = `Update`,
  Duplicate = `Duplicate`,
}

export const trackMetricsEvent = (trackingEvent: MetricsTrackingEvent, data: any = {}) => {
  mixpanel.track(trackingEvent, data);
};

export const getMetricTrackingProps = (metric: Metric | null) => {
  const behavior = metric && `behavior` in metric.definition ? metric.definition.behavior : null;
  const formula = metric && `formula` in metric.definition ? metric.definition.formula : null;
  return {
    behavior,
    behaviorType: behavior?.type,
    behaviorsCount: behavior?.behaviors?.length,
    description: metric?.description,
    display: metric?.definition.display,
    formulaDefinition: formula?.definition,
    formulaReferencedMetrics: formula?.referencedMetrics,
    formulaReferencedMetricsCount: formula?.referencedMetrics?.length,
    formulaContainsSavedMetrics: formula?.referencedMetrics?.some((refMetric) => refMetric.id),
    measurement: metric?.definition.measurement,
    id: metric?.id,
    name: metric?.name,
    type: metric?.type,
  };
};
